export default "__VITE_ASSET__CT4FgCl7__"